export default __webpack_public_path__ + "static/media/whatsapp-black.b2f2284c.svg";